module.exports = __webpack_public_path__ + "static/media/learning.5425556d.svg";